import React, { useState, useEffect } from "react";
import "../styles/Suppliers.css";

// Initial Mock Data to match the exact design in the image
const initialMockData = [
  { id: 1, name: "GreenLife Agro Pvt Ltd", category: "Plants & Seeds", phone: "+91 98765 43210", email: "greenlife@gmail.com", gstin: "33AABFG1234R1Z5", city: "Coimbatore", payable: 68450, status: "Active", isDue: true },
  { id: 2, name: "Sri Garden Supplies", category: "Pots & Accessories", phone: "+91 87654 32109", email: "srigarden@gmail.com", gstin: "33BBHFG5678M1Z2", city: "Chennai", payable: 45230, status: "Active", isDue: true },
  { id: 3, name: "Agri World Traders", category: "Fertilizers", phone: "+91 81234 56789", email: "agriworld@gmail.com", gstin: "33AAKFA7890P1Z1", city: "Madurai", payable: 78650, status: "Active", isDue: true },
  { id: 4, name: "Universal Soil Pvt Ltd", category: "Soil & Media", phone: "+91 90032 14567", email: "unisoil@gmail.com", gstin: "33CCDDF1122Q1Z8", city: "Salem", payable: 22100, status: "Active", isDue: true },
  { id: 5, name: "Kaveri Irrigation Equipments", category: "Irrigation", phone: "+91 93456 78901", email: "kaveriirrigation@gmail.com", gstin: "33AACCX3344R1Z3", city: "Trichy", payable: 15780, status: "Active", isDue: true },
  { id: 6, name: "Green Paradise Nursery", category: "Plants", phone: "+91 98989 65432", email: "greenparadise@gmail.com", gstin: "33BBVVR5566T1Z9", city: "Bangalore", payable: 26340, status: "Inactive", isDue: true },
  { id: 7, name: "Elite Agri Equipments", category: "Machinery", phone: "+91 97531 24680", email: "eliteagri@gmail.com", gstin: "33CCERT7788U1Z7", city: "Coimbatore", payable: 19900, status: "Active", isDue: true },
  { id: 8, name: "Grow More Chemicals", category: "Chemicals", phone: "+91 90909 11223", email: "growmore@gmail.com", gstin: "33AAXXZ9988P1Z4", city: "Chennai", payable: 0, status: "Active", isDue: false },
];

function Suppliers() {
  const [suppliers, setSuppliers] = useState(() => {
    const saved = localStorage.getItem("suppliers");
    return saved ? JSON.parse(saved) : initialMockData;
  });

  const [selectedSupplier, setSelectedSupplier] = useState(suppliers[0] || null);
  const [showModal, setShowModal] = useState(false);

  // Form State
  const [supplierName, setSupplierName] = useState("");
  const [phone, setPhone] = useState("");
  const [gst, setGst] = useState("");
  const [address, setAddress] = useState("");
  const [email, setEmail] = useState("");
  const [category, setCategory] = useState("");
  const [city, setCity] = useState("");

  useEffect(() => {
    localStorage.setItem("suppliers", JSON.stringify(suppliers));
  }, [suppliers]);

  const addSupplier = () => {
    if (!supplierName) return;
    const newSupplier = {
      id: Date.now(),
      name: supplierName,
      category: category || "General",
      phone: phone,
      email: email || "-",
      gstin: gst,
      city: city || "-",
      payable: 0,
      status: "Active",
      isDue: false,
      address: address
    };

    const updatedSuppliers = [...suppliers, newSupplier];
    setSuppliers(updatedSuppliers);
    
    // Reset Form
    setSupplierName(""); setPhone(""); setGst(""); setAddress(""); setEmail(""); setCategory(""); setCity("");
    setShowModal(false);
  };

  const getCategoryClass = (cat) => {
    if (cat.includes("Plants")) return "cat-plants";
    if (cat.includes("Pots")) return "cat-pots";
    if (cat.includes("Fertilizers")) return "cat-fertilizers";
    if (cat.includes("Soil")) return "cat-soil";
    if (cat.includes("Irrigation") || cat.includes("Machinery")) return "cat-machinery";
    if (cat.includes("Chemicals")) return "cat-chemicals";
    return "cat-general";
  };

  return (
    <div className="suppliers-dashboard">
      
      {/* KPI CARDS */}
      <div className="kpi-grid">
        <div className="kpi-card">
          <div className="kpi-icon-box bg-blue">
            <svg width="24" height="24" fill="none" stroke="currentColor" strokeWidth="2" viewBox="0 0 24 24"><path d="M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2"></path><circle cx="9" cy="7" r="4"></circle><path d="M23 21v-2a4 4 0 0 0-3-3.87"></path><path d="M16 3.13a4 4 0 0 1 0 7.75"></path></svg>
          </div>
          <div className="kpi-info">
            <span className="kpi-title">Total Suppliers</span>
            <h2 className="kpi-value">56</h2>
            <span className="kpi-subtitle">Registered</span>
          </div>
        </div>

        <div className="kpi-card">
          <div className="kpi-icon-box bg-green">
            <svg width="24" height="24" fill="none" stroke="currentColor" strokeWidth="2" viewBox="0 0 24 24"><path d="M21 12V7H5a2 2 0 0 1 0-4h14v4"></path><path d="M3 5v14a2 2 0 0 0 2 2h16v-5"></path><path d="M18 12a2 2 0 0 0 0 4h4v-4Z"></path></svg>
          </div>
          <div className="kpi-info">
            <span className="kpi-title">Total Payable</span>
            <h2 className="kpi-value">₹2,76,450</h2>
            <span className="kpi-subtitle">To Suppliers</span>
          </div>
        </div>

        <div className="kpi-card">
          <div className="kpi-icon-box bg-orange">
            <svg width="24" height="24" fill="none" stroke="currentColor" strokeWidth="2" viewBox="0 0 24 24"><path d="M6 2L3 6v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2V6l-3-4z"></path><line x1="3" y1="6" x2="21" y2="6"></line><path d="M16 10a4 4 0 0 1-8 0"></path></svg>
          </div>
          <div className="kpi-info">
            <span className="kpi-title">This Month Purchase</span>
            <h2 className="kpi-value">₹4,85,230</h2>
            <span className="kpi-subtitle">May 2025</span>
          </div>
        </div>

        <div className="kpi-card">
          <div className="kpi-icon-box bg-purple">
            <svg width="24" height="24" fill="none" stroke="currentColor" strokeWidth="2" viewBox="0 0 24 24"><circle cx="9" cy="21" r="1"></circle><circle cx="20" cy="21" r="1"></circle><path d="M1 1h4l2.68 13.39a2 2 0 0 0 2 1.61h9.72a2 2 0 0 0 2-1.61L23 6H6"></path></svg>
          </div>
          <div className="kpi-info">
            <span className="kpi-title">Today's Purchase</span>
            <h2 className="kpi-value">₹18,560</h2>
            <span className="kpi-subtitle">3 Bills</span>
          </div>
        </div>

        <div className="kpi-card">
          <div className="kpi-icon-box bg-teal">
            <svg width="24" height="24" fill="none" stroke="currentColor" strokeWidth="2" viewBox="0 0 24 24"><path d="M22 11.08V12a10 10 0 1 1-5.93-9.14"></path><polyline points="22 4 12 14.01 9 11.01"></polyline></svg>
          </div>
          <div className="kpi-info">
            <span className="kpi-title">Active Suppliers</span>
            <h2 className="kpi-value">49</h2>
            <span className="kpi-subtitle">Active</span>
          </div>
        </div>

        <div className="kpi-card">
          <div className="kpi-icon-box bg-red">
            <svg width="24" height="24" fill="none" stroke="currentColor" strokeWidth="2" viewBox="0 0 24 24"><circle cx="12" cy="12" r="10"></circle><line x1="15" y1="9" x2="9" y2="15"></line><line x1="9" y1="9" x2="15" y2="15"></line></svg>
          </div>
          <div className="kpi-info">
            <span className="kpi-title">Inactive Suppliers</span>
            <h2 className="kpi-value">7</h2>
            <span className="kpi-subtitle">Inactive</span>
          </div>
        </div>
      </div>

      {/* FILTERS & ACTION BAR */}
      <div className="filters-bar">
        <div className="search-wrapper">
          <svg className="search-icon" width="16" height="16" fill="none" stroke="currentColor" strokeWidth="2" viewBox="0 0 24 24"><circle cx="11" cy="11" r="8"></circle><line x1="21" y1="21" x2="16.65" y2="16.65"></line></svg>
          <input type="text" placeholder="Search suppliers by name, phone, GSTIN..." />
        </div>
        
        <div className="select-group">
          <select><option>All Categories</option></select>
          <select><option>All Status</option></select>
          <button className="btn-outline">
            <svg width="14" height="14" fill="none" stroke="currentColor" strokeWidth="2" viewBox="0 0 24 24"><polygon points="22 3 2 3 10 12.46 10 19 14 21 14 12.46 22 3"></polygon></svg>
            More Filters
          </button>
        </div>

        <div className="action-buttons">
          <button className="btn-outline text-blue border-blue">
            <svg width="14" height="14" fill="none" stroke="currentColor" strokeWidth="2" viewBox="0 0 24 24"><path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4"></path><polyline points="7 10 12 15 17 10"></polyline><line x1="12" y1="15" x2="12" y2="3"></line></svg>
            Import
          </button>
          <button className="btn-outline text-green border-green">
            <svg width="14" height="14" fill="none" stroke="currentColor" strokeWidth="2" viewBox="0 0 24 24"><path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4"></path><polyline points="17 8 12 3 7 8"></polyline><line x1="12" y1="3" x2="12" y2="15"></line></svg>
            Export
          </button>
          <button className="btn-primary" onClick={() => setShowModal(true)}>
            + Add Supplier
          </button>
        </div>
      </div>

      {/* MAIN CONTENT SPLIT */}
      <div className="main-split">
        
        {/* TABLE SECTION */}
        <div className="table-container card-panel">
          <table className="custom-table">
            <thead>
              <tr>
                <th>#</th>
                <th>Supplier Name</th>
                <th>Contact Details</th>
                <th>GSTIN</th>
                <th>City</th>
                <th>Payable Amount</th>
                <th>Status</th>
                <th>Actions</th>
              </tr>
            </thead>
            <tbody>
              {suppliers.map((supplier, index) => (
                <tr 
                  key={supplier.id} 
                  className={selectedSupplier?.id === supplier.id ? "selected-row" : ""}
                  onClick={() => setSelectedSupplier(supplier)}
                >
                  <td className="fw-500">{index + 1}</td>
                  <td>
                    <div className="supplier-name-cell">
                      <div className="avatar">
                        <img src={`https://api.dicebear.com/7.x/initials/svg?seed=${supplier.name}&backgroundColor=e5e7eb`} alt="" />
                      </div>
                      <div>
                        <div className="fw-600 text-dark">{supplier.name}</div>
                        <span className={`tag-sm ${getCategoryClass(supplier.category)}`}>{supplier.category}</span>
                      </div>
                    </div>
                  </td>
                  <td>
                    <div className="text-dark fw-500">{supplier.phone}</div>
                    <div className="text-muted text-sm">{supplier.email}</div>
                  </td>
                  <td className="fw-500">{supplier.gstin}</td>
                  <td className="fw-500">{supplier.city}</td>
                  <td>
                    <div className={`fw-600 ${supplier.isDue ? 'text-red' : 'text-green'}`}>
                      ₹{supplier.payable.toLocaleString('en-IN')}
                    </div>
                    <div className={`text-sm ${supplier.isDue ? 'text-red' : 'text-green'}`}>
                      {supplier.isDue ? 'Due' : 'Paid'}
                    </div>
                  </td>
                  <td>
                    <span className={`status-badge ${supplier.status === 'Active' ? 'badge-active' : 'badge-inactive'}`}>
                      {supplier.status}
                    </span>
                  </td>
                  <td>
                    <div className="row-actions">
                      <button className="icon-btn"><svg width="16" height="16" fill="none" stroke="currentColor" strokeWidth="2" viewBox="0 0 24 24"><path d="M1 12s4-8 11-8 11 8 11 8-4 8-11 8-11-8-11-8z"></path><circle cx="12" cy="12" r="3"></circle></svg></button>
                      <button className="icon-btn"><svg width="16" height="16" fill="none" stroke="currentColor" strokeWidth="2" viewBox="0 0 24 24"><path d="M11 4H4a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2v-7"></path><path d="M18.5 2.5a2.121 2.121 0 0 1 3 3L12 15l-4 1 1-4 9.5-9.5z"></path></svg></button>
                      <button className="icon-btn"><svg width="16" height="16" fill="none" stroke="currentColor" strokeWidth="2" viewBox="0 0 24 24"><circle cx="12" cy="12" r="1"></circle><circle cx="12" cy="5" r="1"></circle><circle cx="12" cy="19" r="1"></circle></svg></button>
                    </div>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
          
          <div className="pagination">
            <span className="text-muted text-sm">Showing 1 to {suppliers.length} of 56 suppliers</span>
            <div className="page-controls">
              <button className="page-btn">&lt;</button>
              <button className="page-btn active">1</button>
              <button className="page-btn">2</button>
              <button className="page-btn">3</button>
              <span className="page-dots">...</span>
              <button className="page-btn">7</button>
              <button className="page-btn">&gt;</button>
            </div>
            <div className="per-page text-sm text-muted">
              Show <select className="mini-select"><option>10</option></select> per page
            </div>
          </div>
        </div>

        {/* DETAILS SECTION */}
        {selectedSupplier && (
          <div className="details-container card-panel">
            <div className="details-header">
              <h3>Supplier Details</h3>
              <button className="btn-outline btn-sm border-blue text-blue">View Ledger</button>
            </div>

            <div className="profile-card">
              <div className="profile-avatar">
                <img src={`https://api.dicebear.com/7.x/initials/svg?seed=${selectedSupplier.name}&backgroundColor=f3f4f6`} alt="" />
              </div>
              <div className="profile-info">
                <div className="profile-title">
                  <h4>{selectedSupplier.name}</h4>
                  <span className={`status-badge badge-sm ${selectedSupplier.status === 'Active' ? 'badge-active' : 'badge-inactive'}`}>
                    {selectedSupplier.status}
                  </span>
                </div>
                <span className="text-muted text-sm">{selectedSupplier.category} Supplier</span>
              </div>
            </div>

            <div className="contact-info-list">
              <div className="info-item">
                <svg width="14" height="14" fill="none" stroke="currentColor" strokeWidth="2" viewBox="0 0 24 24"><path d="M22 16.92v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07 19.5 19.5 0 0 1-6-6 19.79 19.79 0 0 1-3.07-8.67A2 2 0 0 1 4.11 2h3a2 2 0 0 1 2 1.72 12.84 12.84 0 0 0 .7 2.81 2 2 0 0 1-.45 2.11L8.09 9.91a16 16 0 0 0 6 6l1.27-1.27a2 2 0 0 1 2.11-.45 12.84 12.84 0 0 0 2.81.7A2 2 0 0 1 22 16.92z"></path></svg>
                <span>{selectedSupplier.phone}</span>
              </div>
              <div className="info-item">
                <svg width="14" height="14" fill="none" stroke="currentColor" strokeWidth="2" viewBox="0 0 24 24"><path d="M4 4h16c1.1 0 2 .9 2 2v12c0 1.1-.9 2-2 2H4c-1.1 0-2-.9-2-2V6c0-1.1.9-2 2-2z"></path><polyline points="22,6 12,13 2,6"></polyline></svg>
                <span>{selectedSupplier.email}</span>
              </div>
              <div className="info-item">
                <svg width="14" height="14" fill="none" stroke="currentColor" strokeWidth="2" viewBox="0 0 24 24"><rect x="3" y="3" width="18" height="18" rx="2" ry="2"></rect><line x1="3" y1="9" x2="21" y2="9"></line><line x1="9" y1="21" x2="9" y2="9"></line></svg>
                <span>{selectedSupplier.gstin}</span>
              </div>
              <div className="info-item align-top">
                <svg width="14" height="14" fill="none" stroke="currentColor" strokeWidth="2" viewBox="0 0 24 24"><path d="M21 10c0 7-9 13-9 13s-9-6-9-13a9 9 0 0 1 18 0z"></path><circle cx="12" cy="10" r="3"></circle></svg>
                <span>{selectedSupplier.address || `124, Agri Compound, Peelamedu,\n${selectedSupplier.city || 'Coimbatore'} - 641004, Tamil Nadu`}</span>
              </div>
            </div>

            <div className="divider"></div>

            <div className="summary-section">
              <div className="summary-header">
                <span className="fw-600">Account Summary</span>
                <select className="mini-select"><option>This Month</option></select>
              </div>
              <div className="summary-row">
                <span className="text-muted">Total Purchase</span>
                <span className="fw-600">₹1,25,450</span>
              </div>
              <div className="summary-row">
                <span className="text-muted">Total Paid</span>
                <span className="fw-600 text-green">₹57,000</span>
              </div>
              <div className="summary-row payable-row">
                <span className="fw-600">Total Payable</span>
                <span className="fw-600 text-red">₹{selectedSupplier.payable.toLocaleString('en-IN')}</span>
              </div>
            </div>

            <div className="divider"></div>

            <div className="transactions-section">
              <div className="transactions-header">
                <span className="fw-600">Recent Transactions</span>
                <a href="#viewall" className="text-blue text-sm fw-500 text-decoration-none">View All</a>
              </div>
              <div className="transaction-list">
                <div className="trx-row"><span>PO-2025-125</span><span className="text-muted">18 May 2025</span><span className="text-red fw-500">₹12,450</span></div>
                <div className="trx-row"><span>PO-2025-118</span><span className="text-muted">15 May 2025</span><span className="text-red fw-500">₹8,750</span></div>
                <div className="trx-row"><span>PO-2025-102</span><span className="text-muted">10 May 2025</span><span className="text-red fw-500">₹15,600</span></div>
                <div className="trx-row"><span>PO-2025-095</span><span className="text-muted">07 May 2025</span><span className="text-red fw-500">₹9,850</span></div>
              </div>
            </div>

            <div className="details-actions">
              <button className="btn-solid-green">
                <svg width="16" height="16" fill="none" stroke="currentColor" strokeWidth="2" viewBox="0 0 24 24"><circle cx="9" cy="21" r="1"></circle><circle cx="20" cy="21" r="1"></circle><path d="M1 1h4l2.68 13.39a2 2 0 0 0 2 1.61h9.72a2 2 0 0 0 2-1.61L23 6H6"></path></svg>
                New Purchase
              </button>
              <button className="btn-solid-blue">
                <svg width="16" height="16" fill="none" stroke="currentColor" strokeWidth="2" viewBox="0 0 24 24"><line x1="12" y1="1" x2="12" y2="23"></line><path d="M17 5H9.5a3.5 3.5 0 0 0 0 7h5a3.5 3.5 0 0 1 0 7H6"></path></svg>
                Payment
              </button>
            </div>
          </div>
        )}
      </div>

      {/* ADD SUPPLIER MODAL */}
      {showModal && (
        <div className="modal-overlay">
          <div className="supplier-modal">
            <h2>Add Supplier</h2>
            <div className="form-grid">
              <input placeholder="Supplier Name" value={supplierName} onChange={(e) => setSupplierName(e.target.value)} />
              <input placeholder="Category (e.g. Plants)" value={category} onChange={(e) => setCategory(e.target.value)} />
              <input placeholder="Phone" value={phone} onChange={(e) => setPhone(e.target.value)} />
              <input placeholder="Email" value={email} onChange={(e) => setEmail(e.target.value)} />
              <input placeholder="GST Number" value={gst} onChange={(e) => setGst(e.target.value)} />
              <input placeholder="City" value={city} onChange={(e) => setCity(e.target.value)} />
              <textarea placeholder="Full Address" className="full-width" value={address} onChange={(e) => setAddress(e.target.value)} />
            </div>
            <div className="modal-actions">
              <button className="btn-outline" onClick={() => setShowModal(false)}>Cancel</button>
              <button className="btn-primary" onClick={addSupplier}>Save Supplier</button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}

export default Suppliers;